import { QueryClient, type Query } from '@tanstack/react-query';
import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import QueryKeys from '@constants/queryKeys';

const PERSISTED_QUERY_KEYS: readonly string[] = [
  QueryKeys.WORKER_OPTIONS,
  QueryKeys.JOB_TITLES,
  QueryKeys.WORKER_FILTERS,
  QueryKeys.WORKER_AVAILABLE_CERTIFICATES,
];

const localStorageAsync = {
  getItem: (key: string) => Promise.resolve(window.localStorage.getItem(key)),
  setItem: (key: string, value: string) =>
    Promise.resolve(window.localStorage.setItem(key, value)),
  removeItem: (key: string) =>
    Promise.resolve(window.localStorage.removeItem(key)),
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const persister = createAsyncStoragePersister({
  storage: localStorageAsync,
  key: 'TH_QUERY_CACHE',
});

export const shouldDehydrateQuery = (query: Query): boolean =>
  query.state.status === 'success' &&
  typeof query.queryKey[0] === 'string' &&
  PERSISTED_QUERY_KEYS.includes(query.queryKey[0]);

export const persistOptions = {
  persister,
  buster: import.meta.env.VITE_APP_VERSION,
  maxAge: Infinity,
  dehydrateOptions: {
    shouldDehydrateQuery,
  },
};
